module.exports = __webpack_public_path__ + "static/img/bar.9303dd9c.png";